import { render, staticRenderFns } from "./IframeDetail.vue?vue&type=template&id=69733642&scoped=true&"
import script from "./IframeDetail.vue?vue&type=script&lang=js&"
export * from "./IframeDetail.vue?vue&type=script&lang=js&"
import style0 from "./IframeDetail.vue?vue&type=style&index=0&id=69733642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69733642",
  null
  
)

export default component.exports